import { computed, getCurrentInstance } from 'vue';
import type VueI18n from 'vue-i18n';
import type { IVueI18n } from 'vue-i18n';
import { useNuxtApp } from '~/.nuxt/imports';

/**
 * vue-i18n 8 has no Composition API, so this wraps the VueI18n instance.
 *
 * `t`/`d` are bound: destructuring them off the instance loses `this`.
 * The `t('key')` call shape matches vue-i18n 9, so a future upgrade is mechanical.
 */
export function useI18n() {
  const vm = getCurrentInstance()?.proxy;
  // Matches vue-i18n's own `Vue.prototype.$i18n: VueI18n & IVueI18n` typing —
  // `locales`/`localeCodes` etc. (added by nuxt-i18n) live on the IVueI18n half.
  const i18n: VueI18n & IVueI18n = vm
    ? vm.$i18n
    : useNuxtApp().nuxt2Context.app.i18n;

  return {
    i18n,
    // Project convention is a string return type, matching plugin-types.d.ts
    t: i18n.t.bind(i18n) as (key: string, attrs?: any) => string,
    d: i18n.d.bind(i18n) as (
      value: number | Date,
      key?: string,
      locale?: string
    ) => string,
    // Kept reactive; `i18n.locale` is a plain property on the instance
    locale: computed(() => i18n.locale)
  };
}
